var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrands = function SvgBrands(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    fill: "none",
    viewBox: "0 0 24 23"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1039_4105)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v23H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2,
    d: "M11.495 8.99a3.995 3.995 0 100-7.99 3.995 3.995 0 000 7.99z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M19 19.807c-.405-2.224.422-4.236-1.314-5.685A9.656 9.656 0 002 19.807h17z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1039_4105)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M20.007 13.582A2.426 2.426 0 0018 14.642a2.407 2.407 0 00-1.188-.92 2.43 2.43 0 00-1.506-.04 2.41 2.41 0 00-1.237.854c-.31.408-.479.904-.483 1.415 0 2.763 3.21 4.243 4.414 5.23 1.204-.987 4.414-2.467 4.414-5.23a2.368 2.368 0 00-.709-1.679 2.41 2.41 0 00-1.698-.69z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1039_4105"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v23H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1039_4105"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v10.909H0z",
    transform: "translate(12 12)"
  })))));
};
export default SvgBrands;